<script setup lang="ts">
import {Plus} from "@lucide/vue";
</script>

<template>
  <router-link :to="{name: 'patient-administration.communication.message.store'}">
    <div class="border-2 gap-1 border-primary flex shadow-sm rounded-full bg-white hover:!bg-primary/10 text-primary items-center px-2 py-1.5 transition-colors">
      <Plus class="size-5" />
      <span class="font-medium text-sm leading-tight">Acheter des crédits</span>
    </div>
  </router-link>
</template>

<style scoped>

</style>
